


















import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import UploadCsvFile, { UploadEvent } from "@/components/inputs/UploadCsvFile.vue";
import { downloadAsFile } from "@/lib/download";

@Component({
  components: {
    CButton,
    UploadCsvFile,
    NoteBox
  }
})
export default class UsersNew extends Vue {
  csv: File | null = null;
  async upload({ text }: UploadEvent) {
    console.log(text);
  }

  async download() {
    const text = "a\nb\nc";
    downloadAsFile("test.csv", "text/csv", text);
  }
}
